import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";
import { previewUpdatePriceState } from "@/store/previewUpdatePriceState";
import { XIcon } from "lucide-react";
import type { FC } from "react";
import Text from "@/components/Text";
import { Button } from "@/components/ui/button";
import { updateSubscriptionPrice } from "@/store/updateSubscriptionPriceState";
import { useTranslation } from "react-i18next";

type Props = {
  onClose: () => void;
  open: boolean;
  isDisabled: boolean;
  priceId: string;
};

const UpdateSubscriptionDialog: FC<Props> = ({
  onClose,
  open,
  isDisabled,
  priceId,
}) => {
  const { t } = useTranslation();
  const { isLoading, data } = previewUpdatePriceState();

  return (
    <Dialog open={open}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <div className="flex justify-between">
            <DialogTitle>{t("subscription_update")}</DialogTitle>
            <XIcon className="cursor:pointer" onClick={() => onClose()} />
          </div>
        </DialogHeader>

        <DialogDescription>
          {isLoading && <Skeleton className="w-full h-[30px] rounded-[8px]" />}

          {data && (
            <div className="flex justify-between">
              <Text fontSize={16} fontWeight={600}>
                {t("total")}
              </Text>
              <Text
                fontSize={22}
                fontWeight={600}
              >{`${data.total / 100} €`}</Text>
            </div>
          )}
        </DialogDescription>
        <DialogFooter>
          <Button variant="secondaryFilled" onClick={() => onClose()}>
            {t("cancel")}
          </Button>
          <Button
            disabled={isDisabled || isLoading}
            onClick={() => {
              updateSubscriptionPrice({
                priceId,
              });
            }}
          >
            {t("update_subscription")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateSubscriptionDialog;
